const SubjectCard = (props) => {
    const { iconSrc, imgSrc, subjectName, chapters, subjectDate, onClick } = props
    return (
        <div className="subject-card" onClick={onClick}>
            <div className="subject-card-header">
                <div className="subject-icon">
                    {iconSrc}
                </div>
                <div className="subject-info">
                    <h4>{subjectName}</h4>
                    <div className="subject-info-wrap">
                        <span className="subject-chapters" onClick={onClick}>{chapters}</span>
                        <span className="dot"></span>
                        <span className="subject-date">{subjectDate}</span>
                    </div>
                </div>
            </div>
            <div className="subject-thumbnail">
                <img src={imgSrc} alt="thumbnail" />
            </div>
        </div>
    )
}
export default SubjectCard;